export default "__VITE_ASSET__DIaetJee__"